// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Fq8VP","truncatedText":"styles_truncatedText__jtAgS","fullText":"styles_fullText__5pzRT","textContainer":"styles_textContainer__xNYt4"};